import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Multiselect } from 'react-widgets';
import { toastr } from 'react-redux-toastr';
import CheckBox from '../../../../components/check-box';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { Lead, Tag } from '../../../../core/api/models';
import { useLead } from '../../../../core';
import 'react-widgets/dist/css/react-widgets.css';
import api from '../../../../api';
import { useMasterData } from '../../../../core/hooks/useMasterData';
import BlockInput from '../../../../components/block-input';
import moment from 'moment';

const MapTag: React.FunctionComponent<{
  leadDetails?: Lead;
  onClose: () => void;
  onSuccess?: () => void;
}> = (props) => {
  const [Tags, setTags] = React.useState([
    { label: 'Cool' },
    { label: 'Hot' },
    { label: 'Warm' },
    { label: 'Supercar' },
    { label: 'Luxury' },
    { label: 'Sporty' },
    { label: 'Speed' },
    { label: 'Drive' },
    { label: 'Amazing' },
  ]);
  const { updateTags } = useLead(api.lead);
  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
    watch,
  } = useForm<Tag>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: false,
  });

  React.useEffect(() => {
    if (props.leadDetails?.tags) {
      setValue('tags', props.leadDetails?.tags);
    }
  }, []);

  const onSubmit = async (data: Tag) => {
    const updateData: Tag = {
      tags: data.tags,
    };

    updateTags(updateData, props.leadDetails?._id, () => {
      props.onClose?.();
      props.onSuccess?.();
      toastr.success('Success', 'Tags updated successfully');
    });
  };
  const tags = watch('tags') as string[];

  const handleCreate = (tag: string) => {
    const newOption = {
      label: tag,
    };
    Tags.push(newOption);
    setTags(Tags);
    const newTags = tags || props.leadDetails?.tags || [];
    newTags.push(tag);
    setValue('tags', newTags);
  };

  const resetTag = () => {
    const updateData: Tag = {
      tags: [],
    };

    updateTags(updateData, props.leadDetails?._id, () => {
      setValue('tags', []);
      props.onClose?.();
    });
  };

  return (
    <div className="accordion__body pt-2 pb-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm ">
            Type to get saved tags & if you didn't find your tag add the tag
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="tags"
            defaultValue={tags}
            render={({ onChange, value, name }) => (
              <Multiselect
                value={value}
                data={Tags}
                defaultValue={value}
                textField={'label'}
                valueField={'label'}
                placeholder={'Select Tags'}
                onChange={(val) => {
                  onChange(val?.map((x) => x.label));
                }}
                allowCreate="onFilter"
                autoFocus={true}
                onCreate={(tagName) => handleCreate(tagName)}
              />
            )}
          />
          {errors.tags && <ErrorMessage>Tag is required</ErrorMessage>}
        </div>

        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <div className="text-right">
            {/* <button
              type="button"
              onClick={resetTag}
              disabled={!tags || !tags.length}
              className="btn mr-2 btn-primary py-2 font-weight-semibold font-normal px-4 "
            >
              Reset
            </button> */}
            <button
              // disabled={!tags || !tags.length}
              className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MapTag;
